import styled from 'styled-components'
import Clickable from 'components/Common/Clickable'
import LineEditAltIcon from 'LuxKit/Icons/line/LineEditAltIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import focusStyle from 'styles/utils/focusStyle'
import { tripPlannerNavigationRowStyle } from './tripPlannerNavigationRowStyle'

const NEW_CHAT_ICON = <LineEditAltIcon />

const Row = styled(Clickable)`
  ${tripPlannerNavigationRowStyle}

  &[aria-current='page'] {
    background-color: ${props => props.theme.palette.neutral.surface.lightBackgroundAlt};
  }

  &:focus-visible {
    ${focusStyle}
  }
`

interface Props {
  label: string
  selected: boolean
  onClick: () => void
}

function TripPlannerNewChatRow({ label, selected, onClick }: Props) {
  return (
    <Row aria-current={selected ? 'page' : undefined} onClick={onClick}>
      {NEW_CHAT_ICON}
      <BodyText variant="medium">{label}</BodyText>
    </Row>
  )
}

export default TripPlannerNewChatRow
